export const REWARDS_BANNER_TITLE_COPY = "Customize";
export const REWARDS_BANNER_SUBTITLE_COPY =
  "Add or decline these options to continue";
export const CUSTOMIZE_HEADER_TITLE = "Ticket option";
